<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="currentSociety"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :cols="currentPlayer === undefined ? '12' : '6'"
        class="list-overflow"
      >
        <v-list>
          <v-list-item-group v-model="currentPlayer">
            <v-list-item
              v-for="player in playerData"
              :key="player.key"
            >
              <v-list-item-title>{{ player.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="currentPlayer !== undefined"
        cols="6"
      >
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="playerData[currentPlayer].name"
                :rules="[rules.required]"
                :label="$t('profile.sections.common.name')"
                dense
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="playerData[currentPlayer].city"
                :append-icon="cityOther.length > 0 ? 'mdi-map-marker-multiple' : 'mdi-map-marker-question'"
                :label="$t('status.city')"
                dense
                @input="resetOtherCity()"
                @click:append="setCityInfo()"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="playerData[currentPlayer].dpt"
                :label="$t('status.department')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="playerData[currentPlayer].lat"
                :label="$t('profile.sections.player.lat')"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="playerData[currentPlayer].lng"
                :label="$t('profile.sections.player.lng')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="11">
              <v-text-field
                v-model="playerData[currentPlayer].identifier"
                :rules="[rules.required]"
                :label="$t('profile.sections.player.license')"
                disabled
                readonly
                dense
              />
            </v-col>
            <v-col cols="1">
              <v-btn
                icon
                @click="copy(playerData[currentPlayer].identifier)"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="success"
                :disabled="
                  playerData[currentPlayer].name.length < 1 ||
                  playerData[currentPlayer].lat.length == 0 ||
                  playerData[currentPlayer].lng.length == 0
                "
                @click="updatePlayerData(playerData[currentPlayer].id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <button-dialog-delete
                :text="$t('popup.user')"
                @ok-pushed="disablePlayer(playerData[currentPlayer].plyr_id)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../../Common/ButtonDialogDelete";

// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";
const geoApi = require("../../Tools/GeoApi");

export default {
  components: {
    buttonDialogDelete,
  },
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      currentSociety: 0,
      socData: [],
      currentPlayer: undefined,
      playerData: [],
      cityOther: [],
      cityIndex: 0,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
      },
    };
  },
  watch: {
    currentPlayer: function () {
      this.resetOtherCity();
    },
    currentSociety: function (val) {
      this.currentPlayer = undefined;
      this.getPlayerForSoc(val);
    },
  },
  created() {
    this.getSociety();
  },
  methods: {
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;
      });
    },
    getPlayerForSoc(val) {
      this.societyConnector.getPlayerForSoc(val).then((players) => {
        // TODO: format in db server
        this.playerData = players.map((data) => {
          return {
            plyr_id: data.plyr_id,
            name: data.name,
            dpt: data.dpt,
            city: data.city,
            lat: parseFloat(data.lat),
            lng: parseFloat(data.lng),
            identifier: data.identifier,
          };
        });
      });
    },
    setCityInfo() {
      if (this.cityOther.length > 0) {
        this.cityIndex++;

        if (this.cityIndex >= this.cityOther.length) {
          this.cityIndex = 0;
        }

        this.playerData[this.currentPlayer].city = this.cityOther[this.cityIndex].city;
        this.playerData[this.currentPlayer].dpt = this.cityOther[this.cityIndex].dpt;
        this.playerData[this.currentPlayer].lat = this.cityOther[this.cityIndex].lat;
        this.playerData[this.currentPlayer].lng = this.cityOther[this.cityIndex].lng;
      } else {
        const currentCity = this.playerData[this.currentPlayer].city;

        if (currentCity.length > 0) {
          geoApi
            .getCityInfo(currentCity)
            .then((response) => {
              if (response.length > 0) {
                if (response.length > 1) {
                  this.cityOther = response.map((elem) => {
                    return {
                      city: elem.nom,
                      dpt: elem.departement.nom,
                      lat: elem.centre.coordinates[1],
                      lng: elem.centre.coordinates[0],
                    };
                  });
                }

                // If only one result
                this.playerData[this.currentPlayer].city = response[0].nom;
                this.playerData[this.currentPlayer].dpt = response[0].departement.nom;
                this.playerData[this.currentPlayer].lat = response[0].centre.coordinates[1];
                this.playerData[this.currentPlayer].lng = response[0].centre.coordinates[0];
              } else {
                this.resetCity();
              }
            })
            .catch((err) => {
              console.error(err);
              this.resetCity();
            });
        } else {
          this.resetCity();
        }
      }
    },
    resetCity() {
      this.playerData[this.currentPlayer].city = "";
      this.playerData[this.currentPlayer].dpt = "";
      this.playerData[this.currentPlayer].lat = "";
      this.playerData[this.currentPlayer].lng = "";
    },
    resetOtherCity() {
      this.cityOther = [];
      this.cityIndex = 0;
    },
    copy(license) {
      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(license).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", license);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    disablePlayer(player) {
      this.societyConnector.delPlayer(player).finally(() => {
        this.currentPlayer = undefined;
        this.getPlayerForSoc(this.currentSociety);
      });
    },
    updatePlayerData() {
      this.societyConnector
        .updatePlayer(this.playerData[this.currentPlayer])
        .then(() => {
          this.currentPlayer = undefined;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
